export default __webpack_public_path__ + "media/assets/img/img_icon_legende-5740f1ef2687a8cfe4a2dad53756a702.svg";